var React = require('react');

function GithubIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.99.38a13.97 13.97 0 00-4.62 27.18c.73.19.62-.34.62-.7v-2.41c-4.24.5-4.41-2.31-4.7-2.78-.57-.98-1.93-1.23-1.52-1.7.96-.5 1.95.12 3.09 1.8.82 1.23 2.43 1.02 3.25.82.17-.73.56-1.39 1.08-1.9-4.4-.79-6.22-3.47-6.22-6.66 0-1.54.5-2.96 1.5-4.11-.63-1.9.06-3.51.16-3.75 1.81-.16 3.7 1.3 3.85 1.41 1.03-.27 2.2-.42 3.53-.42 1.32 0 2.5.15 3.54.43.36-.27 2.1-1.52 3.8-1.37.08.24.77 1.82.17 3.69a6.15 6.15 0 011.52 4.13c0 3.2-1.84 5.88-6.25 6.66a3.99 3.99 0 011.2 2.84v3.52c.02.28 0 .56.46.56A13.99 13.99 0 0014 .38z","fill":"currentColor"}));
}

GithubIcon.defaultProps = {"viewBox":"0 0 28 28","fill":"none"};

module.exports = GithubIcon;

GithubIcon.default = GithubIcon;
